// todo update me
export enum CustomFonts {
    // todo register fonts here
    // Roboto400 = 'Roboto-400',
}
